module.exports = __webpack_public_path__ + "img/Dima.d1573537.png";